module.exports = __webpack_public_path__ + "static/media/brand3.bb877eb4.png";